export default {
    titles: {
        gem_guide: 'GEM GUIDE',
    },
    views:{
        home_page: "HOME PAGE",
        services: "SERVICES",
        news: "NEWS",
        about_us: "ABOUT US",
        job_chance: "JOB CHANCE",
        contact_us: "CONTACT US",
    },
    menus: [
        "HOME",
        "PRODUCTS",
        "GEM STONES",
        "NEWS",
        "ABOUT US",
        "CONTACT US",
    ],
    contents: {
        gem_guide_desc1: 'Learn about the properties, conditions and chakras of gemstones.',
        gem_guide_desc2: 'Our lab-grown gemstones are cultured just like you would culture a pearl. We create a sustainable environment to duplicate nature, and over the course of about a year, gemstone crystals grow. As a result, the crystals have the chemical, physical, and optical properties that are identical to that of mined gems without costing the earth.'
    },
    products: {
        rings: "RINGS",
        earrings: "EARRINGS",
        bracelets: "BRACELETS",
        necklaces: "NECKLACES"
    },
    company: {
        about_us: "ABOUT US",
        name: "Zhejiang Yuhan Jewelry Company",
        desc: "Zhejiang Yuhan Jewelry Company was founded in 2012. We started from a small studio workshop by dealing in pearls, since pearls are living jewels which display aura and elegance. Thanks to years of diligent work and our customers’ constant support, we were able to develop into a global company that can offer variety of fine jewelry styles.",
        detail: `<p>Our mission is to offer high-quality, affordable jewelry to every customer.</p><br>
<p>Why do we work in jewelry?</p><br>
An interest in jewelry conveys a high sense of fashion. Premium jewelry displays sophistication, elegance and taste, and this can be seen in the jewelry that people choose to wear.
Jewelry is the pursuit and yearning of human beings, a label that shows femininity and our true personality.<br>
Natural jewelry is gorgeous, but we want to be an affordable and exquisite jewelry brand, so we found that lab cultured gemstones are good alternatives. Combining our many years of jewelry design, inlay technology and stone selection, we can present the charm of lab grown jewelry. Lab grown gemstones, such as ruby, sapphire, emerald, aquamarine can reach the same physical features including composition, hardness, relative density, refractive index and clarity. As well as the essential styles, we also offer a customized design service.<br>
<p>What we want to express femininity:</p><br>
Beauty, elegance, independence, self-confidence, wisdom, perseverance, the precipitation of time, light, companionship, love and be loved
If you are lucky enough to have all of these qualities, then our jewelry will be the icing on the cake for you.<br>
If everything in life is not perfect now, then may our jewelry become a light in the dark, bringing courage and strength to move forward!<br>
<p>Remember, you are unique in this world, you are very precious!</p>`
    },
    contact_info: {
        title: "Consult with our jewelry specialist.",
        name: "name",
        content: "message",
        submit: "submit",
        telephone: "tel",
        email: "email",
        fax: "fax",
        comment: "We are proud to offer 24/7 service for our customers",
        hint: "Please contact us as soon as possible"
    },
    tips: [
        "Our SuperHero Collection is designed with natural, sliced gemstones.",
        "Our Victorian-inspired earrings are designed with the most precious single-cut gems.",
        "Our Elixir Collection is designed with natural gems set to be in direct contact with your skin.",
        "Our fashion jewelry is a testament to the rich cultural and curative heritage of craftsmanship and gemstones. Each piece reflects functionality, beauty and purpose.",
        "Our Adele Ruby & Diamond Earrings are designed with natural, single-cut pink ruby and diamond encrusted balls. ",
    ]
}


// WEBPACK FOOTER //
// ./src/lang/locale/en-US.js